import React, { useState, useEffect } from "react";
import axios from "../axios";
import "../App.css";

function Search({ handleSubmit, setMultiplier }) {
  const [type, setType] = useState("");
  const [colorCodes, setColorCodes] = useState([]);

  useEffect(() => {
    const fetchTypeAndCode = async () => {
      try {
        const response = await axios.get(`/colors/${type}`);
        let fetchedColorCodes = [];
        response.data.map((color) => fetchedColorCodes.push(color.code));
        setColorCodes([...fetchedColorCodes]);
      } catch (err) {
        console.error(err);
      }
    };
    if (type !== "") {
      fetchTypeAndCode();
    }
  }, [type]);

  return (


    <div className="row justify-content-center searchContainer no-print">
        <div className="row justify-content-center searchContainer no-print">
            <a href="https://fusion-legacy.screenprinting.com">To view the legacy Fusion mixing app, click here.</a>
        </div>
      <div className="col-md-12 col-sm-12 col-xs-12 no-print">
        <div className="col-md-12" style={{ marginBottom: "15px" }}>
            <br></br>
            <h5>
            The Fusion Color Mixer maps the Pantone Colors to the specific
            mixing formula using the Green Galaxy Fusion mixing system.
          </h5>
        </div>
        <form
          onSubmit={(e) => handleSubmit(e)}
          className="row row-cols-md-auto justify-content-center"
        >
          <div className="form-group col-md-4 col-sm-10 col-xs-10">
            <label htmlFor="category" className="futuraBold">
              Type:
            </label>
            <select
              id="category"
              name="category"
              className="form-select"
              required
              defaultValue=""
              onChange={(e) => setType(e.target.value)}
            >
              <option hidden value="">
                Choose...
              </option>
              <option value="UD">Uncoated Direct to Fabric</option>
              <option value="CD">Coated Direct to Fabric</option>
            </select>
          </div>
          <div className="form-group col-md-3 col-sm-10 col-xs-10">
            <label htmlFor="code" className="futuraBold">
              Code:
            </label>
            <select
              id="code"
              name="colorCode"
              className="form-select"
              required
              defaultValue=""
            >
              <option hidden value="">
                Choose...
              </option>
              {colorCodes.map((code, index) => (
                <option key={code + index} value={code}>
                  {code}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group col-md-2 col-sm-6 col-xs-10 justify-content-center">
            <input
              id="gramsInput"
              name="gramsInput"
              type="number"
              className="form-control"
              required
              defaultValue={1000}
              onChange={(e) => setMultiplier(e)}
            />
            <label
              htmlFor="gramsInput"
              id="gramsLabel"
              className="col-form-label"
            >
              grams
            </label>
          </div>
          <div
            className="col-md-3 col-sm-6 col-xs-10"
            style={{
              padding: 0,
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
            }}
          >
            <button
              className="btn btn-lg btn-ryoForest futuraBold"
              style={{ paddingTop: 12, paddingBottom: 12, fontSize: 16 }}
              type="submit"
            >
              Get Formula
            </button>
            <a
              href="https://3518025.extforms.netsuite.com/app/site/crm/externalcasepage.nl/compid.3518025/.f?formid=53&h=AACffht_NlqQ3WZfbQNFdOGY1wYYEep8xus&redirect_count=1&title=Fusion%20New%20Pantone%20Request&did_javascript_redirect=T"
              target="_blank"
              style={{ color: "#000000" }}
            >
              <button
                id="requestPantone"
                type="button"
                className="btn futuraBold"
                style={{
                  backgroundColor: "#eaeaea",
                  fontSize: "12px",
                }}
              >
                Request New&nbsp;Pantone
              </button>
            </a>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Search;
